import { apiCall } from "../configs/axiosConfigs";
const BASE_URL = `/ecommerce/artist`;

const withQuery = (base, params) => {
  if (!params) return base;
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return qs ? `${base}?${qs}` : base;
};

export const artistsApi = {
  async getBestSellerArtist(payload) {
    return apiCall({
      url: `${BASE_URL}/getBestSellerArtist`,
      method: "POST",
      data: payload
    });
  }
};

export const urlMakePageFetcherArtist = {
  url: `${BASE_URL}/getBestSellerArtist`,
  method: "POST"
};

export { withQuery };
